/**
 * Fired when a request is rejected by a 422 whose error bag carries one of
 * `MODAL_VALIDATION_ERROR_KEYS` — a message meant for the user that belongs to no form field.
 */
export const GLOBAL_VALIDATION_ERROR_EVENT = 'diagonal:global-validation-error';

export interface GlobalValidationErrorDetail {
  message: string;
}
